module.exports = __webpack_public_path__ + "static/visitor_bg-9288fa7e875e8850b7e0b31eb3a6ffc3.png";